var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 6,
    height: 14,
    rx: 3,
    stroke: "#9EAEBA",
    strokeWidth: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5V12C5 15.866 8.13401 19 12 19V19C15.866 19 19 15.866 19 12V9.5",
    stroke: "#9EAEBA",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19V23",
    stroke: "#9EAEBA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C16.5523 24 17 23.5523 17 23C17 22.4477 16.5523 22 16 22V24ZM8 22C7.44772 22 7 22.4477 7 23C7 23.5523 7.44772 24 8 24V22ZM16 22H8V24H16V22Z",
    fill: "#9EAEBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.7f03c2334f991af1053f083d279ad8fc.svg";
export { ForwardRef as ReactComponent };